// extracted by mini-css-extract-plugin
export default {"cookieConsentFlow":"soho-cookie-consent-flow-wrapper_cookieConsentFlow__JCU-d"};